/**
 * Utilidades para validar archivos antes de subirlos
 */
// Límites de tamaño en bytes
export const MAX_FILE_SIZE_IMAGES = 15 * 1024 * 1024; // 15 MB para imágenes (incluyendo logo)
export const MAX_FILE_SIZE_DOCUMENTS = 50 * 1024 * 1024; // 50 MB para documentos
/**
 * Valida el tamaño de un archivo y retorna un mensaje de error si excede el límite
 */
export const validateFileSize = (
  file: File,
  maxSize: number,
  fileType: 'image' | 'document' = 'document'
): { valid: boolean; error?: string; maxSizeMB: number; fileSizeMB: number } => {
  const fileSizeMB = file.size / (1024 * 1024);
  const maxSizeMB = maxSize / (1024 * 1024);
  if (file.size > maxSize) {
    return {
      valid: false,
      error: `El archivo "${file.name}" es demasiado grande (${fileSizeMB.toFixed(2)} MB). El tamaño máximo permitido es ${maxSizeMB.toFixed(0)} MB.`,
      maxSizeMB,
      fileSizeMB
    };
  }
  return {
    valid: true,
    maxSizeMB,
    fileSizeMB
  };
};
/**
 * Valida múltiples archivos y retorna el primer error encontrado
 */
export const validateMultipleFiles = (
  files: File[],
  maxSize: number,
  fileType: 'image' | 'document' = 'document'
): { valid: boolean; error?: string; maxSizeMB: number; fileSizeMB?: number; fileName?: string } => {
  for (const file of files) {
    const validation = validateFileSize(file, maxSize, fileType);
    if (!validation.valid) {
      return {
        valid: false,
        error: validation.error,
        maxSizeMB: validation.maxSizeMB,
        fileSizeMB: validation.fileSizeMB,
        fileName: file.name
      };
    }
  }
  return {
    valid: true,
    maxSizeMB: maxSize / (1024 * 1024)
  };
};